// @core/api/endpoints/audittrail/create_retention_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateRetentionPolicyRequest,
  RetentionPolicyResponse,
} from '../../../types/audittrail';

const BASE_PATH = '/audittrail';

/**
 * Create retention policy
 * Creates a new data retention policy defining how long audit records are kept and what happens upon expiration.
 */
export async function CreateRetentionPolicy(
  data: CreateRetentionPolicyRequest,
  options?: RequestOptions
): Promise<RetentionPolicyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/audit/retention-policies`;
  const requestOptions = options;
  return client.post<RetentionPolicyResponse>(requestPath, data, requestOptions);
}
